(function () {
  function initDrawerOffset() {
    const modal = document.getElementById('modal-main-menu');
    if (!modal || !modal.classList.contains('modal--mega-dropdown')) return;
    const header =
      document.querySelector('.header.js-header') ||
      document.querySelector('.section-header .header') ||
      document.querySelector('.header');
    if (!header) return;

    let raf = null;
    const update = () => {
      const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      modal.style.setProperty('--mega-drawer-top', bottom + 'px');
    };
    const schedule = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    };

    const trigger = document.querySelector('[data-a11y-dialog-show="modal-main-menu"]');
    let isOpen = false;

    modal.addEventListener('on:modal:opening', update);

    modal.addEventListener('on:modal:opened', () => {
      isOpen = true;
      document.documentElement.classList.add('mega-drawer-open');
      update();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    });

    modal.addEventListener('on:modal:closed', () => {
      isOpen = false;
      document.documentElement.classList.remove('mega-drawer-open');
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
    });

    if (trigger) {
      trigger.addEventListener(
        'click',
        (e) => {
          if (isOpen && typeof modal.close === 'function') {
            e.preventDefault();
            e.stopImmediatePropagation();
            modal.close();
          } else {
            update();
          }
        },
        true
      );
    }

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerOffset);
  } else {
    initDrawerOffset();
  }
})();

if (!customElements.get('mega-mobile-dropdown')) {
  customElements.define(
    'mega-mobile-dropdown',
    class MegaMobileDropdown extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.mega-mob__toggle');
        this.panel = this.querySelector('.mega-mob__panel');
        if (!this.toggle || !this.panel) return;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onTransitionEnd = this.onTransitionEnd.bind(this);

        this.toggle.addEventListener('click', this.onClick);
        this.toggle.addEventListener('keydown', this.onKeydown);
        this.panel.addEventListener('transitionend', this.onTransitionEnd);
      }

      disconnectedCallback() {
        this.toggle.removeEventListener('click', this.onClick);
        this.toggle.removeEventListener('keydown', this.onKeydown);
        this.panel.removeEventListener('transitionend', this.onTransitionEnd);
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      onClick() {
        this.isOpen ? this.close() : this.open();
      }

      onKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          this.onClick();
        }
      }

      open() {
        this.toggle.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
        this.panel.hidden = false;
        this.panel.style.maxHeight = '0px';
        void this.panel.offsetHeight;
        this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
      }

      close() {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
        this.panel.style.maxHeight = `${this.panel.scrollHeight}px`;
        void this.panel.offsetHeight;
        this.panel.style.maxHeight = '0px';
      }

      onTransitionEnd(event) {
        if (event.propertyName !== 'max-height') return;
        if (this.isOpen) {
          this.panel.style.maxHeight = 'none';
        } else {
          this.panel.hidden = true;
          this.panel.style.maxHeight = '';
        }
      }
    }
  );
}
